import React, { useCallback, useContext, useEffect, useState } from 'react';

import ProgramDashboardContext from '@totem/components/services/optimize/v2/dashboard/ProgramDashboardContext';
import { ProgramDashboard } from '@totem/components/services/optimize/v2/dashboard/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  buildingId: string;
  programId: string;
  children: React.ReactNode;
};

const ProgramDashboardContainer = ({
  buildingId,
  programId,
  children,
}: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [dashboard, setDashboard] = useState<ProgramDashboard | null>(null);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (!refresh) {
      return;
    }

    setRefresh(false);

    setLoading(true);

    fetch(
      `${BUILDINGS_ENDPOINT}/${buildingId}/optimize/programs/${programId}/dashboard`,
      {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      },
    )
      .then((res) => res.json())
      .then((result: ProgramDashboard) => {
        setDashboard(result ?? null);
      })
      .finally(() => setLoading(false));
  }, [refresh, buildingId, programId, getApiToken]);

  const requestRefresh = useCallback(() => setRefresh(true), []);

  return (
    <ProgramDashboardContext.Provider
      value={{ buildingId, programId, dashboard, loading, requestRefresh }}
    >
      {children}
    </ProgramDashboardContext.Provider>
  );
};

export default ProgramDashboardContainer;
